import aelyraImg from "@/assets/instructor-aelyra.png";
import caelionImg from "@/assets/instructor-caelion.png";
import vaelorImg from "@/assets/instructor-vaelor.png";

export type InstructorCategory = "finance" | "economics" | "entrepreneurship";

export interface Instructor {
  name: string;
  category: InstructorCategory;
  image: string;
}

export const INSTRUCTORS: Record<InstructorCategory, Instructor> = {
  finance: { name: "Aelyra", category: "finance", image: aelyraImg },
  economics: { name: "Caelion Veyr", category: "economics", image: caelionImg },
  entrepreneurship: { name: "Vaelor", category: "entrepreneurship", image: vaelorImg },
};

// Explicit course → category mapping (covers all 46 courses).
const COURSE_CATEGORY: Record<string, InstructorCategory> = {
  // Economics
  "Behavioral Economics": "economics",
  "Economic Development & Institutions": "economics",
  "Economic Foundations": "economics",
  "Economic History": "economics",
  "Economic Systems in Practice": "economics",
  "Fiscal Policy & Government Economics": "economics",
  "Game Theory & Strategic Interaction": "economics",
  "International Economics": "economics",
  "Labor Economics": "economics",
  "Macroeconomic Foundations": "economics",
  "Market Structures & Competition": "economics",
  "Microeconomics": "economics",
  "Money, Banking & Central Banking": "economics",

  // Entrepreneurship
  "Business & Startup Expansion": "entrepreneurship",
  "Business Fundamentals": "entrepreneurship",
  "Business Model Design": "entrepreneurship",
  "Company Case Studies": "entrepreneurship",
  "Entrepreneurial Finance": "entrepreneurship",
  "Entrepreneurial Foundations": "entrepreneurship",
  "Founder Decision-Making": "entrepreneurship",
  "Growth & Scale": "entrepreneurship",
  "Offer Creation & Validation": "entrepreneurship",
  "Operations & Execution": "entrepreneurship",
  "Opportunity Identification": "entrepreneurship",
  "Ownership, Equity & Exit Strategy": "entrepreneurship",
  "Sales & Marketing Fundamentals": "entrepreneurship",
  "Startups & Entrepreneurship": "entrepreneurship",

  // Finance (default for all remaining personal-finance, investing, real-estate, career, etc.)
  "Advanced Financial Strategy": "finance",
  "Banking & Cash Management": "finance",
  "Behavioral Finance": "finance",
  "Career & Income Strategy": "finance",
  "Credit & Debt Management": "finance",
  "Family Finance": "finance",
  "Financial Confidence System": "finance",
  "Financial Foundations": "finance",
  "Financial Recovery": "finance",
  "Financial Scams & Fraud Awareness": "finance",
  "Insurance & Risk Protection": "finance",
  "Investing Fundamentals": "finance",
  "Real Estate (Homeownership)": "finance",
  "Real Estate Development": "finance",
  "Real Estate Investing": "finance",
  "Retirement & Investment Accounts": "finance",
  "Saving & Budgeting": "finance",
  "Taxes": "finance",
  "Transportation & Vehicle Ownership": "finance",
};

export function getInstructorCategory(courseName?: string | null): InstructorCategory {
  if (!courseName) return "finance";
  const direct = COURSE_CATEGORY[courseName];
  if (direct) return direct;

  // Heuristic fallback for any future / unmapped course names.
  const lower = courseName.toLowerCase();
  if (/(econom|macro|micro|fiscal|monetary|game theory|labor|market structure)/.test(lower)) {
    return "economics";
  }
  if (/(entrepreneur|startup|business|founder|sales|marketing|offer|operations|growth|equity|exit|company case)/.test(lower)) {
    return "entrepreneurship";
  }
  return "finance";
}

export function getInstructorForCourse(courseName?: string | null): Instructor {
  return INSTRUCTORS[getInstructorCategory(courseName)];
}
